import {
    Table,
    Button,
    ButtonGroup,
    ButtonToolbar,
    DropdownButton
} from 'react-bootstrap';

export const TradingZonesTable = ({
    tradingZones,
    handleEditZone,
    handleDeleteZone,
}) => {

    return (
        <div>
            {tradingZones && tradingZones.length > 0 &&
                <Table striped bordered hover>
                    <thead>
                        <tr>
                            <th>Ticker</th>
                            <th>Type</th>
                            <th>Min</th>
                            <th>Max</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {tradingZones.map(zone => {
                            return (
                                <tr key={zone.id}>
                                    <td>{zone.ticker}</td>
                                    <td>{zone.type}</td>
                                    <td>{zone.min}</td>
                                    <td>{zone.max}</td>
                                    <td>
                                            <ButtonGroup size="sm">
                                                <Button
                                                    size="sm"
                                                    variant="primary"
                                                    onClick={() => handleEditZone(zone)}>
                                                    Edit
                                                </Button>
                                                <Button
                                                    size="sm"
                                                    variant="secondary"
                                                    onClick={() => handleDeleteZone(zone)}>
                                                    Delete
                                                </Button>
                                            </ButtonGroup>
                                    </td>
                                </tr>
                            );
                        })
                        }
                    </tbody>
                </Table>
            }
        </div>


    )
}